import React, { FC } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DownloadIcon from '@mui/icons-material/Download';
import { ScannerCase } from 'models/scanner-case';
import { File as DenthubFile } from 'models/file';

type ScannerCaseDenthubFileTableProps = {
    scannerCase: ScannerCase;
};
const ScannerCaseDenthubFileTable: FC<ScannerCaseDenthubFileTableProps> = ({ scannerCase }) => {
    const { t: translate } = useTranslation(['common', 'scan-cases']);

    const handleDownloadClick = (file: DenthubFile) => {
        const link = document.createElement('a');
        link.href = file.url;
        link.download = file.filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <TableContainer>
            <Table size="small">
                <TableHead sx={{ borderBottom: 'none' }}>
                    <TableRow>
                        <TableCell>{translate('common:FILES')}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {scannerCase.processedFiles.map((file: DenthubFile) => (
                        <TableRow
                            key={file._id}
                            sx={{ cursor: 'pointer' }}
                            hover
                            onClick={() => handleDownloadClick(file)}
                        >
                            <TableCell>{file.filename}</TableCell>
                            <TableCell sx={{ textAlign: 'right' }}>
                                <Button
                                    onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                                        event.stopPropagation();
                                        handleDownloadClick(file);
                                    }}
                                    startIcon={<DownloadIcon />}
                                >
                                    {translate('common:DOWNLOAD')}
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ScannerCaseDenthubFileTable;
